import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Product } from '../../generic/classes/product';
import { ProductDetail } from '../../generic/classes/product.detail';
import { Logger } from '../../generic/logging/default-log.service';
import { FilterService } from '../../generic/service/filter.service';
import { ProductService } from '../../generic/service/product.service';
import { UserService } from '../../generic/service/user.service';
import { RelatedProductsComponent } from './related.products.component';
import { LazyLoadDirective } from '../../generic/component/lazyload/ng-lazy-load.directive';
import { ProductItemGridComponent } from '../../generic/component/products/productitem.grid.component';

/**
 * Used to show more products of the given grower. Works similar to 'spotlight' products but with less options.
 * Spotlight products is used primarily in the website and not the shop, so this component can be setup simpler.
 *
 * @author evandongen
 */
@Component({
    templateUrl: './grower.products.component.html',
    selector: 'grower-products',
    styleUrls: ['./alternative_grower.products.component.scss'],
    standalone: true,
    imports: [ProductItemGridComponent, LazyLoadDirective],
})
export class GrowerProductsComponent
    extends RelatedProductsComponent
    implements OnInit {
    @Input() product: ProductDetail;

    filterStateUrl: string;
    productOverviewUrl: string;

    constructor(
        public productService: ProductService,
        public domElement: ElementRef,
        public filterService: FilterService,
        public router: Router,
        userService: UserService,
        public logger: Logger,
    ) {
        super(
            productService,
            domElement,
            filterService,
            router,
            userService,
            logger,
        );
    }

    ngOnInit() {
        // We set the properties in the ngOnInit method because somehow the @Input properties are not set yet when we put these properties
        // in the class directly. Where this.limit is being inherited from the parent class.
        this.filterStateUrl = `?includefeatures=false&pageSize=${this.limit}&page=1&sorting=random&grower=${this.product.grower}`;
        this.productOverviewUrl = `/products?grower=${this.product.grower}`;

        super.ngOnInit();
    }

    /**
     * Filter from the complete list of growers products the main product shown.
     * Main product is identified by the product.priceListLineNo.
     *
     * @param {Product[]} products as complete product list of this grower.
     * @return {Product[]} List without the main product.
     */
    filterProductsOfPriceListLineNo(products: Product[]) {
        return products.filter(
            product => product.priceListLineNo !== this.product.priceListLineNo,
        );
    }
}
